const simulator = {
  title1: 'Simulez votre financement',
  title2: "Besoin d'un crédit, faites vos simultions en ligne !",
  recap: 'Récapitulatif',
  monthlyPayment: 'Paiement mensuel',
  during: 'Pendant',
  month: 'Mois',
  dh: 'DH',
  furtherInfo:
    'Vous souhaitez obtenir des informations complémentaires? Envoyez-nous vos coordonnées et nous nous engageons à vous apporter une réponse dans les plus brefs délais.',
  requestLoanHeaderTitle: 'Demandez un crédit',
  requestLoanTitle: 'Pour demander un crédit',
  requestLoan: 'Demander ce crédit',
  simulation:
    '*Le résultat de cette simulation est donné à titre indicatif. Il ne constituera en aucun cas un engagement contractuel de la part de la Banque Populaire',
  investmentTabTitle: 'Investissement',
  amount: 'Montant',
  rate: 'Taux',
  duration: 'Durée',
  delay: 'Différé',
  creditSimulator: ' Simulateur de crédit',
  copyright: 'COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS',
  goback: 'Retour',
  horsTaxes: '(hors taxes)',
};

export default simulator;
